//Types for Login
export const AUTH_LOGIN = 'auth/login';
//Types for Logout
export const AUTH_LOGOUT = 'auth/logout';
